import { apiClient } from "../../../zodios/client";
import { errorToast } from "../../../utils/toasts";

// Error toast copy is passed in pre-translated by the (component) caller, since this
// plain util can't use the useTranslation hook.
interface WalmartOAuthErrorToast {
  title: string;
  message: string;
}

export const initWalmartMpOauth = async (
  orgId?: string | number,
  errorToastContent?: WalmartOAuthErrorToast,
): Promise<void> => {
  // Walmart sends the user back to where they started, success or not.
  const returnPath = window.location.pathname + window.location.search;
  try {
    const { redirect_url } = await apiClient.initWalmartOauth({
      queries: {
        org_id: orgId !== undefined ? orgId.toString() : undefined,
        success_path: returnPath,
        error_path: returnPath,
      },
    });
    window.location.href = redirect_url;
  } catch (error) {
    if (errorToastContent) {
      errorToast({ title: errorToastContent.title, message: errorToastContent.message, error });
    }
  }
};
